import { render, staticRenderFns } from "./SafetyQuestions.vue?vue&type=template&id=2c30259f&"
import script from "./SafetyQuestions.vue?vue&type=script&lang=js&"
export * from "./SafetyQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports